import React from "react";
import {graphql, PageProps} from "gatsby";
import {getSrc} from "gatsby-plugin-image";

import Layout from "../components/layouts/layout/Layout";
import Sections, {Section} from "../components/layouts/sections/Sections";

import HeaderInfo from "../components/header-info/HeaderInfo";

export default function IndexPage({
  data,
}: PageProps<Queries.HomePageQueryQuery>) {
  const {contentfulPromoBanner, contentfulProductPageTemplate} = data;

  const {sections, headerInfo} = contentfulProductPageTemplate || {};

  return (
    <Layout promoBannerData={contentfulPromoBanner}>
      {headerInfo && (
        <HeaderInfo
          title={headerInfo.title!}
          noindexNofollow={headerInfo.noindexNofollow!}
          image={getSrc(headerInfo.image!)}
          description={headerInfo.description!}
        />
      )}
      <Sections sections={sections as Array<Section>} isHomePage />
    </Layout>
  );
}

export const query = graphql`
  query HomePageQuery($locale: String!, $homePageId: String!) {
    contentfulPromoBanner(
      node_locale: {eq: $locale}
      contentful_id: {eq: "17z8sGPISXmsBtu2jynvvp"}
    ) {
      ...PromoBannerFragment
    }
    contentfulProductPageTemplate(
      node_locale: {eq: $locale}
      contentful_id: {eq: $homePageId}
    ) {
      headerInfo {
        ...HeaderInfoFragment
      }
      sections {
        __typename
        ... on ContentfulHeroSideBySideModule {
          ...HeroSideBySideModuleFragment
        }
        ... on ContentfulFeaturedContentModule {
          ...FeaturedContentModuleFragment
        }
        ... on ContentfulCarousel {
          ...CarouselFragment
        }
        ... on ContentfulSplitModule {
          ...SplitModuleFragment
        }
        ... on ContentfulImageVideoTextStacked {
          ...ImageVideoTextStackedFragment
        }
        ... on ContentfulQuoteModule {
          ...QuoteModuleFragment
        }
        ... on ContentfulPartnershipModule {
          ...PartnershipModuleFragment
        }
        ... on ContentfulFastFacts {
          ...FastFactsFragment
        }
        ... on ContentfulGetStartedModule {
          ...GetStartedModuleFragment
        }
        ... on ContentfulScrollTakeoverModule {
          ...ScrollTakeoverModuleFragment
        }
        ... on ContentfulFaq {
          ...FaqFragment
        }
        ... on ContentfulCargoInsuranceCards {
          ...CargoInsuranceCardsFragment
        }
        ... on ContentfulGlobalReachMap {
          ...GlobalReachMapFragment
        }
        ... on ContentfulLinkCollection {
          ...LinkCollectionFragment
        }
        ... on ContentfulCardCarousel {
          ...CardCarouselFragment
        }
        ... on ContentfulTest {
          ...TestFragment
        }
      }
    }
  }
`;
